import { Routes, Route } from 'react-router-dom';
import { AdminPage } from './pages/AdminPage';

export function AdminApp() {
  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/*" element={<AdminPage />} />
    </Routes>
  );
}
